import { Injector, Injectable } from '@angular/core';
import { cgpAuthentication } from '../../../modules/cgp-authentication';
import { BaseHttpService } from '../../shared/base-http.service';
import { HttpParams, HttpClient } from '@angular/common/http';
import { CgpAlertDialogService } from '../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { servicesUrl } from './ve.config';
import { utilities, getEnv } from '../../../../src/modules/utility';

export abstract class VEService extends BaseHttpService {
    protected readonly tableName: string;
    // Mesc service
    protected readonly BASE_URL: string;
    // Module service

    constructor(
        injector: Injector,
        tableName: string,
    ) {
        super(injector);
        this.tableName = tableName;
        this.BASE_URL = servicesUrl[getEnv()];
    }

    /**
     *
     */
    read = (path = '', catchError = true): Promise<any> => super.fetch(this.getUrl() + this.tableName + path, catchError);

    /**
     *
     */
    search = (body: any, path = '', catchError = true, searchParams: HttpParams = null): Promise<any> => {
        return super.post(body, this.getUrl() + this.tableName + path, catchError, searchParams);
    }
    /**
     *
     */
    save = (obj, isNew: boolean, path = '', catchError = true): Promise<any> => {
        return isNew ? super.post(obj, this.getUrl() + this.tableName + path, catchError) : super.put(obj, this.getUrl() + this.tableName + path, catchError);
    }
    /**
     *
     */
    uploadExcel = (obj, isNew: boolean, path = '', catchError = true): Promise<any> => super.post_excel(obj, this.getUrl() + this.tableName + path, catchError);
    /**
     *
     */
    applyThroughput = (obj, isNew: boolean, path = '', catchError = true): Promise<any> => super.put(obj, this.getUrl() + this.tableName + path, catchError);
    /**
     *
     */
    applyParts = (obj, isNew: boolean, path = '', catchError = true): Promise<any> => super.post_excel(obj, this.getUrl() + this.tableName + path, catchError);
    /**
     *
     */
    remove = (path: string, catchError = true): Promise<any> => super.delete(this.getUrl() + this.tableName + path, catchError);
    /**
     *
     */
    export = (body: any, path = '', searchParams: HttpParams = null): Promise<any> => super.download(body, this.getUrl() + this.tableName + path, searchParams);
    /**
     *
     */
    documentDownload = (path = '', searchParams: HttpParams = null): Promise<any> => super.documentDownload(this.getUrl() + this.tableName + path, searchParams);
    /**
     *
     */
    getCGPUser = (gmin: string, catchError = true): Promise<any> => super.fetch(`${this.getUrl()}common/User/CgpUserByGminGmid?gminGmid=${gmin}`, catchError);
    /**
     *
     */
    getAuthToken = () => cgpAuthentication.getAuthToken();
    /**
     *
     */
    private readonly getCurrentUserGmin = (): string => cgpAuthentication.getUserInfo().gmuniqueidentifier;

    protected getUrl(): string {
        return this.BASE_URL;
    }
}


@Injectable()
export class BaseService extends VEService {
    constructor(injector: Injector) { super(injector, ''); }
}

@Injectable()
export class ModuleService extends VEService {
    constructor(injector: Injector) { super(injector, 'common/Module'); }
}

@Injectable()
export class UserService extends VEService {
    constructor(injector: Injector, private readonly cgpAlertDialog: CgpAlertDialogService) {
        super(injector, 'common/User');
        this.httpErrorHeader = 'User Error';
    }
}

@Injectable()
export class UserProfileService extends VEService {
    constructor(injector: Injector) { super(injector, 'common/User/UserProfile'); }
}

@Injectable()
export class UserSettingsService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/UserSettings'); }
}

@Injectable()
export class RoleService extends VEService {
    constructor(injector: Injector) { super(injector, 'common/Role'); }
}

@Injectable()
export class UserLastLoginDateService extends VEService {
    constructor(injector: Injector) { super(injector, 'common/User/LastLoginDate'); }
}

@Injectable()
export class AuthorizationService extends VEService {
    constructor(injector: Injector) {super(injector, '/common/Authorization'); }
}

@Injectable()
export class GateService extends VEService {
    constructor(injector: Injector) { super(injector, '/common/Gate'); }
}

@Injectable()
export class ArchitectureService extends VEService {
    constructor(injector: Injector) { super(injector, '/ga/Architecture'); }
}

@Injectable()
export class SmtService extends VEService {
    constructor(injector: Injector) { super(injector, '/GA/SMT'); }
}

@Injectable()
export class MBOMService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/mBOM'); }
}

@Injectable()
export class ToolingOperatorService extends VEService {
    constructor(injector: Injector) { super(injector, '/GA/ToolingOperatorInterface'); }
}

@Injectable()
export class RequestTypeService extends VEService {
    constructor(injector: Injector) { super(injector, '/body/RequestType'); }
}
@Injectable()
export class DeliverablesService extends VEService {
    constructor(injector: Injector) { super(injector, '/Body/Deliverables'); }
}
@Injectable()
export class AddInfoCategoryService extends VEService {
    constructor(injector: Injector) { super(injector, '/GA/AddInfoCategory'); }
}
@Injectable()
export class CMEAreaService extends VEService {
    constructor(injector: Injector) { super(injector, '/GA/CMEArea'); }
}
@Injectable()
export class StudyTitlesService extends VEService {
    constructor(injector: Injector) { super(injector, '/GA/StudyTitles'); }
}

@Injectable()
export class TotalVehicleNumberService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/TotalVehicleNumber'); }
}

@Injectable()
export class TrackingVehicleNumberService extends VEService {
    constructor(injector: Injector) { super(injector, '/common/TrackingVehicleNumber'); }
}

@Injectable()
export class BannerService extends VEService {
    constructor(injector: Injector) { super(injector, '/common/Banner'); }
}

@Injectable()
export class AreaService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/Area'); }
}

@Injectable()
export class ProgramDetailsGAService extends VEService {
    constructor(injector: Injector) { super(injector, '/GA/GAProgramDetails'); }
}

@Injectable()
export class ProgramDetailsBodyService extends VEService {
    constructor(injector: Injector) { super(injector, '/Body/BodyProgramDetails'); }
}

@Injectable()
export class PlantService extends VEService {
    constructor(injector: Injector) { super(injector, '/common/MescCore/Plant'); }
}

@Injectable()
export class ProgramService extends VEService {
    constructor(injector: Injector) { super(injector, '/common/MescCore/Programs'); }
}

@Injectable()
export class ZoneService extends VEService {
    constructor(injector: Injector) { super(injector, '/common/MescCore/Zones'); }
}

@Injectable()
export class GlobalRegionService extends VEService {
    constructor(injector: Injector) { super(injector, '/common/MescCore/GlobalRegion'); }
}

@Injectable()
export class WorkOrderNotificationService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/WorkOrderNotification'); }
}

@Injectable()
export class GAWorkOrderService extends VEService {
    constructor(injector: Injector) { super(injector, '/GA/GAWorkOrder'); }
}

@Injectable()
export class BodyWorkOrderService extends VEService {
    constructor(injector: Injector) { super(injector, '/Body/BodyWorkOrder'); }
}

@Injectable()
export class WorkOrderService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/WorkOrder'); }
}

@Injectable()
export class WorkOrderHistoryService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/WorkOrderHistory'); }
}

@Injectable()
export class HolidayScheduleService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/HolidaySchedule'); }
}

@Injectable()
export class WorkOrderScheduleService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/WorkOrderSchedule'); }
}

@Injectable()
export class DocumentService extends VEService {
    constructor(injector: Injector) { super(injector, '/common/Document'); }
    getUploadUrl = (moduleName, isReportDocument) => {
        return `${super.getUrl()}${this.tableName}/Uploadfile?moduleName=${moduleName}&isReportDocument=${isReportDocument}`;
    }
}

@Injectable()
export class EngineerScheduleService extends VEService {
    constructor(injector: Injector) { super(injector, '/Common/EngineerSchedule'); }
}
